export interface IWorkOrder {
    id: number;
    date?: string;
    createdBy?: string;
    sendDate?: Date;
    sendBy?: string;
    status: string;
    trackingNumber: string;
    vendorId?: number;
    groupSentId?: number;
}

const newWorkOrder = (): IWorkOrder => ({
    id: 0,
    status: '',
    trackingNumber: ''
})

export const createWorkOrder = <T extends Partial<IWorkOrder>>(initialValues: T): IWorkOrder & T => {
    return Object.assign(newWorkOrder(), initialValues);
};
